export const INFRA_MAPPING = {
  dev: "dev-env.smarterhealth.dev",
  staging: "staging-env.smarterhealth.dev",
  prod: "platform.smarterhealth.sg",
};
